import { string } from "yup";
import "yup-phone-lite";

export const phoneNumber = () =>
  string().phone(
    ["US", "CA"],
    "Phone number is not valid. Example phone number: (123) 123-1234"
  );

export const optionalPhoneNumber = () =>
  string()
    .transform((v) => (!v ? undefined : v))
    .phone(
      ["US", "CA"],
      "Phone number is not valid. Example phone number: (123) 123-1234"
    )
    .optional();
